export const filterData = (data: any, dataType: string) =>
  data?.filter((item: any) => item?.dataType === dataType);
